import script from "./MenuMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuMobile.vue?vue&type=script&setup=true&lang=js"

import "./MenuMobile.vue?vue&type=style&index=0&id=c3b8cf6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3b8cf6e"]])

export default __exports__